module.exports = __webpack_public_path__ + "img/box6_icon4.2d31ff78.jpg";